module.exports = __webpack_public_path__ + "images/icons/flags/GB-2cae0134.svg";